"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = exports.getKeys = void 0;
var imports_1 = require("../../../lib/imports");
var common_sidecar_1 = require("../../../main/common-sidecar");
var textInputs_sidecar_1 = require("../../../uiParts/textInputs-sidecar");
var rogueHotkeys_sidecar_1 = require("../monofont/rogueHotkeys-sidecar");
var rogueCursor_sidecar_1 = require("../ui/rogueCursor-sidecar");
var rogueInput_1 = require("./rogueInput");
require("./rogueInput-sidecar");
var rogueKeyboard_directInput_sidecar_1 = require("./rogueKeyboard_directInput-sidecar");
var rogueRunMode_sidecar_1 = require("./rogueRunMode-sidecar");
var keys = {
    godMode: false,
    shift: false,
    control: false,
    alt: false,
    cameraUp: false,
    cameraDown: false,
    cameraLeft: false,
    cameraRight: false,
};
var getKeys = function () {
    return keys;
};
exports.getKeys = getKeys;
var _handlers = [];
var addHandler = function (codes, on, off, change) {
    if (on === void 0) { on = function () { }; }
    if (off === void 0) { off = function () { }; }
    if (change === void 0) { change = function () { }; }
    if (!imports_1.l.isArray(codes)) {
        codes = [codes];
    }
    imports_1.l.forEach(codes, function (c) {
        _handlers.push({ code: c, on: on, off: off, change: change });
    });
};
var addKey = function (codes, property) {
    addHandler(codes, function () { }, function () { }, function (isDown) {
        // console.log('key property changed', codes, property, isDown)
        rogueCursor_sidecar_1.rogueCursor.setInputKeyboard();
        keys[property] = isDown;
    });
};
var addCommandKey = function (codes, command) {
    addHandler(codes, function () { }, function () { }, function (isDown) {
        rogueCursor_sidecar_1.rogueCursor.setInputKeyboard();
        if (isDown) {
            (0, rogueInput_1.setNextInputCommand)(command);
        }
    });
};
var addCommandKeyWithRun = function (codes, command) {
    addHandler(codes, function () { }, function () { }, function (isDown) {
        rogueCursor_sidecar_1.rogueCursor.setInputKeyboard();
        if (isDown) {
            (0, rogueInput_1.setNextInputCommandAndRunIfNotAlreadyRunning)(command);
        }
        if (!isDown) {
            // up
            rogueRunMode_sidecar_1.rogueRunMode.cancelRunMode();
        }
    });
};
var create = function () {
    var s = common_sidecar_1.common.getPhaserScene();
    imports_1.l.forEach(textInputs_sidecar_1.textInputs.textInputAlphabet, function (c) {
        s.input.keyboard.addKey(c);
    });
    addKey(['ShiftLeft', 'ShiftRight'], 'shift');
    addKey(['ControlLeft', 'ControlRight'], 'control');
    addKey(['AltLeft', 'AltRight'], 'alt');
    // addKey('KeyW', 'cameraUp')
    // addKey('KeyA', 'cameraLeft')
    // addKey('KeyS', 'cameraDown')
    // addKey('KeyD', 'cameraRight')
    addCommandKeyWithRun('Numpad4', rogueInput_1.EInputCommand.moveLeft);
    addCommandKeyWithRun('Numpad6', rogueInput_1.EInputCommand.moveRight);
    addCommandKeyWithRun('Numpad8', rogueInput_1.EInputCommand.moveUp);
    addCommandKeyWithRun('Numpad2', rogueInput_1.EInputCommand.moveDown);
    addCommandKeyWithRun('Numpad5', rogueInput_1.EInputCommand.moveWait);
    addCommandKeyWithRun('KeyA', rogueInput_1.EInputCommand.moveLeft);
    addCommandKeyWithRun('KeyD', rogueInput_1.EInputCommand.moveRight);
    addCommandKeyWithRun('KeyW', rogueInput_1.EInputCommand.moveUp);
    addCommandKeyWithRun('KeyS', rogueInput_1.EInputCommand.moveDown);
    addCommandKeyWithRun('ArrowLeft', rogueInput_1.EInputCommand.moveLeft);
    addCommandKeyWithRun('ArrowRight', rogueInput_1.EInputCommand.moveRight);
    addCommandKeyWithRun('ArrowUp', rogueInput_1.EInputCommand.moveUp);
    addCommandKeyWithRun('ArrowDown', rogueInput_1.EInputCommand.moveDown);
    addCommandKey('Escape', rogueInput_1.EInputCommand.cancel);
    addCommandKey('KeyI', rogueInput_1.EInputCommand.openInventory);
    addCommandKey('KeyZ', rogueInput_1.EInputCommand.openCastMenu);
    addCommandKey('Enter', rogueInput_1.EInputCommand.select);
    addCommandKey(['NumpadAdd', 'Equal'], rogueInput_1.EInputCommand.zoomIn);
    addCommandKey(['NumpadSubtract', 'Minus'], rogueInput_1.EInputCommand.zoomOut);
    addCommandKeyWithRun('Space', rogueInput_1.EInputCommand.select);
    addCommandKey('KeyM', rogueInput_1.EInputCommand.openMessages);
    addCommandKey('KeyP', rogueInput_1.EInputCommand.openMessages);
    addCommandKey('F1', rogueInput_1.EInputCommand.openHelp);
    addCommandKey('F2', rogueInput_1.EInputCommand.openStory);
    addCommandKey('Slash', rogueInput_1.EInputCommand.openHelp);
    addCommandKey('F8', rogueInput_1.EInputCommand.resetGame);
    s.input.keyboard.on('keydown', function (event) {
        console.log('key down', 'key', event.key, 'keyCode', event.keyCode, 'code', event.code);
        // if (underMenuController.handleKeydown(event.code)) {
        //   return
        // }
        if (textInputs_sidecar_1.textInputs.hasFocus()) {
            textInputs_sidecar_1.textInputs.handleKeyboardInput(event.key, event.keyCode, event.code);
        }
        else {
            if (rogueKeyboard_directInput_sidecar_1.rogueKeyboard_directInput.isKeyEntryMode()) {
                // Direct keyboard entry
                rogueKeyboard_directInput_sidecar_1.rogueKeyboard_directInput.process(event.key);
            }
            else if (rogueHotkeys_sidecar_1.rogueHotkeys.testAll(event.key)) {
                // Test menu keys first
            }
            else {
                imports_1.l.forEach(_handlers, function (c) {
                    if (c.code === event.code) {
                        if (c.on) {
                            c.on();
                        }
                        if (c.change) {
                            c.change(true);
                        }
                    }
                });
            }
            // if (settings.get().devMode || true) {
            //   if (event.code === 'NumpadMultiply') {
            //     _underTestRigCreator.createStarredTestRig()
            //   }
            // }
            // if (event.code === 'KeyE') {
            //   goatCameraShaker.shake()
            // }
        }
    });
    s.input.keyboard.on('keyup', function (event) {
        // if (event.code === 'ControlLeft') {
        //   keys.godMode = false
        // }
        // if (event.code === 'ShiftLeft') {
        //   keys.shift = false
        // }
        // if (event.code === 'ShiftRight') {
        //   keys.shift = false
        // }
        if (textInputs_sidecar_1.textInputs.hasFocus()) {
            // textInputs.handleKeyboardInput(event.key, event.keyCode, event.code)
        }
        else {
            imports_1.l.forEach(_handlers, function (c) {
                if (c.code === event.code) {
                    if (c.off) {
                        c.off();
                    }
                    if (c.change) {
                        c.change(false);
                    }
                }
            });
        }
        // if (underMenuController.handleKeyup(event.code)) {
        //   return
        // }
        // if (event.key === 'y') {
        //   perf.setUpdatePerformanceEnabled(false)
        // }
    });
};
exports.create = create;
